module.exports = __webpack_public_path__ + "img/program_2.6333f198.png";